import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=d522ac16&scoped=true&"
import script from "./file-upload.vue?vue&type=script&lang=js&"
export * from "./file-upload.vue?vue&type=script&lang=js&"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=d522ac16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d522ac16",
  null
  
)

export default component.exports